// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ReportDetailsModal_backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.ReportDetailsModal {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    position: relative;
}

.ReportDetailsModal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
}

.ReportDetailsModal_header h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
}

.ReportDetailsModal_close {
    background: none;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
}

.ReportDetailsModal_close:hover {
    background: #f5f5f5;
}

.ReportDetailsModal_content {
    padding: 20px;
}

.ReportDetailsModal_section {
    margin-bottom: 25px;
}

.ReportDetailsModal_section:last-child {
    margin-bottom: 0;
}

.ReportDetailsModal_section h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 5px;
}

.ReportDetailsModal_info {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ReportDetailsModal_info_item {
    font-size: 14px;
    color: #555;
}

.ReportDetailsModal_info_item strong {
    color: #333;
    font-weight: 600;
}

.ReportDetailsModal_message {
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 15px;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    word-wrap: break-word;
}

.ReportDetailsModal_screenshot {
    text-align: center;
}

.ReportDetailsModal_screenshot_image {
    max-width: 100%;
    max-height: 400px;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ReportDetailsModal_logs {
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    max-height: 300px;
    overflow-y: auto;
}

.ReportDetailsModal_log_item {
    display: flex;
    padding: 8px 12px;
    border-bottom: 1px solid #e8e8e8;
    font-family: 'Courier New', monospace;
    font-size: 12px;
}

.ReportDetailsModal_log_item:last-child {
    border-bottom: none;
}

.ReportDetailsModal_log_item--log {
    background: rgba(0, 0, 0, 0.02);
}

.ReportDetailsModal_log_item--warn {
    background: rgba(255, 193, 7, 0.1);
    color: #856404;
}

.ReportDetailsModal_log_item--error {
    background: rgba(220, 53, 69, 0.1);
    color: #721c24;
}

.ReportDetailsModal_log_item--info {
    background: rgba(13, 202, 240, 0.1);
    color: #055160;
}

.ReportDetailsModal_log_time {
    margin-right: 12px;
    color: #666;
    flex-shrink: 0;
    min-width: 140px;
}

.ReportDetailsModal_log_type {
    margin-right: 12px;
    font-weight: bold;
    flex-shrink: 0;
    min-width: 60px;
}

.ReportDetailsModal_log_message {
    word-break: break-word;
    flex: 1;
}

.ReportDetailsModal_no_logs {
    padding: 20px;
    text-align: center;
    color: #666;
    font-style: italic;
}

/* Responsive */
@media (max-width: 768px) {
    .ReportDetailsModal {
        width: 95%;
        margin: 10px;
    }
    
    .ReportDetailsModal_log_item {
        flex-direction: column;
        gap: 4px;
    }
    
    .ReportDetailsModal_log_time,
    .ReportDetailsModal_log_type {
        min-width: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/administrator/ReportDetailsModal.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gCAAgC;IAChC,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":["\n.ReportDetailsModal_backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n}\n\n.ReportDetailsModal {\n    background: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n    position: relative;\n}\n\n.ReportDetailsModal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 1;\n}\n\n.ReportDetailsModal_header h2 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #333;\n}\n\n.ReportDetailsModal_close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #666;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background-color 0.2s;\n}\n\n.ReportDetailsModal_close:hover {\n    background: #f5f5f5;\n}\n\n.ReportDetailsModal_content {\n    padding: 20px;\n}\n\n.ReportDetailsModal_section {\n    margin-bottom: 25px;\n}\n\n.ReportDetailsModal_section:last-child {\n    margin-bottom: 0;\n}\n\n.ReportDetailsModal_section h3 {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n    border-bottom: 2px solid #f0f0f0;\n    padding-bottom: 5px;\n}\n\n.ReportDetailsModal_info {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.ReportDetailsModal_info_item {\n    font-size: 14px;\n    color: #555;\n}\n\n.ReportDetailsModal_info_item strong {\n    color: #333;\n    font-weight: 600;\n}\n\n.ReportDetailsModal_message {\n    background: #f9f9f9;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 15px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #333;\n    word-wrap: break-word;\n}\n\n.ReportDetailsModal_screenshot {\n    text-align: center;\n}\n\n.ReportDetailsModal_screenshot_image {\n    max-width: 100%;\n    max-height: 400px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.ReportDetailsModal_logs {\n    background: #f9f9f9;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.ReportDetailsModal_log_item {\n    display: flex;\n    padding: 8px 12px;\n    border-bottom: 1px solid #e8e8e8;\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n}\n\n.ReportDetailsModal_log_item:last-child {\n    border-bottom: none;\n}\n\n.ReportDetailsModal_log_item--log {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n.ReportDetailsModal_log_item--warn {\n    background: rgba(255, 193, 7, 0.1);\n    color: #856404;\n}\n\n.ReportDetailsModal_log_item--error {\n    background: rgba(220, 53, 69, 0.1);\n    color: #721c24;\n}\n\n.ReportDetailsModal_log_item--info {\n    background: rgba(13, 202, 240, 0.1);\n    color: #055160;\n}\n\n.ReportDetailsModal_log_time {\n    margin-right: 12px;\n    color: #666;\n    flex-shrink: 0;\n    min-width: 140px;\n}\n\n.ReportDetailsModal_log_type {\n    margin-right: 12px;\n    font-weight: bold;\n    flex-shrink: 0;\n    min-width: 60px;\n}\n\n.ReportDetailsModal_log_message {\n    word-break: break-word;\n    flex: 1;\n}\n\n.ReportDetailsModal_no_logs {\n    padding: 20px;\n    text-align: center;\n    color: #666;\n    font-style: italic;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .ReportDetailsModal {\n        width: 95%;\n        margin: 10px;\n    }\n    \n    .ReportDetailsModal_log_item {\n        flex-direction: column;\n        gap: 4px;\n    }\n    \n    .ReportDetailsModal_log_time,\n    .ReportDetailsModal_log_type {\n        min-width: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
